/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  HTTPValidationError,
  PatentAnalysisRequest,
  PatentAnalysisResponse,
  PatentSearchRequest,
  PatentSearchResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Patent<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description Realiza una búsqueda exhaustiva de patentes según la Decisión 486 de la CAN y la normativa de la Superintendencia de Industria y Comercio (SIC).
   *
   * @tags patents
   * @name SearchPatentsEndpointPatentSearchPost
   * @summary Búsqueda de Patentes
   * @request POST:/patent/search
   */
  searchPatentsEndpointPatentSearchPost = (
    data: PatentSearchRequest,
    params: RequestParams = {}
  ) =>
    this.request<PatentSearchResponse, HTTPValidationError>({
      path: `/patent/search/v2`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Analiza la patentabilidad de una invención según los criterios de la Decisión 486 de la CAN y los lineamientos de la SIC.
   *
   * @tags patents
   * @name AnalyzePatentabilityEndpointPatentAnalyzePost
   * @summary Análisis de Patentabilidad
   * @request POST:/patent/analyze
   */
  analyzePatentabilityEndpointPatentAnalyzePost = (
    data: PatentAnalysisRequest,
    params: RequestParams = {}
  ) =>
    this.request<PatentAnalysisResponse, HTTPValidationError>({
      path: `/patent/analyze`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Obtiene los requisitos de patentabilidad según la normativa colombiana
   *
   * @tags patents
   * @name GetPatentRequirementsPatentRequirementsGet
   * @summary Requisitos de Patentabilidad
   * @request GET:/patent/requirements
   */
  getPatentRequirementsPatentRequirementsGet = (params: RequestParams = {}) =>
    this.request<Record<string, Record<string, string>>, any>({
      path: `/patent/requirements`,
      method: "GET",
      format: "json",
      ...params,
    });
}
